// UWAGA: Wykorzystane w OPAC
import BsModalController from "../modal_controller"

// usage:
//   through 'layouts/frame/modal'
//   (renders automatically with 'Turbo-Frame=modal' request header)
export default class extends BsModalController {
  connect () {
    super.connect()
    // opens automatically when returned from server
    this._bsComponent.show()
  }

  disconnect () {
    // hide is required to call scrollBar.reset() (#B20-824)
    // (clicking link inside modal frame renders new modal and disconnects this one)
    this.hide()
    super.disconnect()
  }

  submitEnd (e) {
    const submitter = e.detail.formSubmission.submitter
    if (submitter.name === 'button' && submitter.formMethod === 'get') {
      return // dont hide modal, render turbo-frame inside
    }
    if (e.detail.success) {
      // TODO: consider this.element.remove() - form not longer needed
      this.hide()
    }
  }
}
